// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"398":"6fc52b56","536":"b66053ad","684":"4b31ed97","886":"1097a2dc","952":"b0fcef73"}[chunkId] + ".chunk.css";
};